module.exports = __webpack_public_path__ + "img/1676356924847-Screenshot_2023-02-14-14-41-11-86_1c337646f29875672b5a61192b9010f9.jpg.4d832643.webp";